import { Box, Flex, Group, List, Paper } from "@mantine/core";
import fourthSocialLogo from "shared/assets/images/fourthSocial.svg";
import headerLogo from "shared/assets/images/headerLogo.svg";
import telegramLogo from "shared/assets/images/telegram.svg";
import bankLogo from "shared/assets/images/vector-bank-logo.svg";
import whatsUpLogo from "shared/assets/images/whatsUp.svg";
import youtubeLogo from "shared/assets/images/youtube.svg";
import { useMobile } from "shared/hooks/useMobile";
import { Link } from "shared/ui/_links/Link";

import { PageContainer } from "components/_common/_page/PageContainer";
import BootstrapGrid from "shared/ui/BootstrapGrid";
import styles from "./index.module.scss";

const MENU = [
  { label: "Проекты", to: "/projects" },
  // { label: "Калькулятор", to: "/landing" },
  { label: "Документы", to: "/platform-docs" },
  { label: "Новости и статьи", to: "/news" },
];

const SOCIAL_ICONS = [
  {
    src: whatsUpLogo,
    bg: styles.bgWhatsUp,
    size: { width: 18, height: 18 },
    padding: { top: 17, left: 17 },
  },
  {
    src: telegramLogo,
    border: styles.bordered,
    size: { width: 24, height: 20 },
    padding: { top: 17, left: 12 },
  },
  {
    src: youtubeLogo,
    border: styles.bordered,
    size: { width: 30, height: 21 },
    padding: { top: 16, left: 11 },
  },
  {
    src: fourthSocialLogo,
    border: styles.bordered,
    size: { width: 33, height: 33 },
    padding: { top: 9, left: 9 },
  },
];

export const Footer = () => {
  const { setOption } = useMobile();

  return (
    <PageContainer pt={0} pb={0} component={"footer"}>
      <BootstrapGrid.Row>
        <BootstrapGrid.Item without={"Pb"}>
          <Paper
            className={styles.footer}
            style={{
              padding: `${setOption("16px 32px", "64px")}`,
            }}
          >
            <Flex
              align="center"
              justify="space-between"
              mb={24}
              style={{
                flexDirection: `${setOption("column", "row")}`,
              }}
              gap="32px"
            >
              <Flex
                direction="column"
                className={styles.logoContainer}
                style={{
                  alignItems: `${setOption("center", "")}`,
                }}
                gap="8px"
              >
                <img alt="Header Logo" src={headerLogo} width={150} />
                <Flex className={styles.bankInfo}>
                  <Box className={styles.bankLogo}>
                    <img alt="Bank Logo" src={bankLogo} />
                  </Box>
                  <Box className={styles.bankText} c={"layout.9"}>
                    Включен Банком России в реестр операторов инвестиционных платформ. Лицензия №123
                  </Box>
                </Flex>
              </Flex>

              <List className={styles.menu}>
                <Group gap="md" align="center">
                  {MENU.map(({ label, to }, index) => (
                    <Link
                      key={index}
                      to={to}
                      c="--mantine-color-layout-4"
                      className={styles.menuLink}
                    >
                      {label}
                    </Link>
                  ))}
                </Group>
              </List>

              <Flex className={styles.socialIcons}>
                {SOCIAL_ICONS.map(({ src, bg, border, size, padding }, index) => (
                  <Flex
                    key={index}
                    className={`${styles.socialIcon} ${bg} ${border}`}
                    style={{ padding: bg ? 17 : undefined }}
                  >
                    <img
                      alt={`Social Icon ${index + 1}`}
                      src={src}
                      width={size?.width || "100%"}
                      height={size?.height || "100%"}
                      style={padding ? padding : undefined}
                    />
                  </Flex>
                ))}
              </Flex>

              <Link to={"tel:74954456145"} c={"dark"} className={styles.phoneNumber}>
                +7 (495) 445-61-45
              </Link>
            </Flex>

            <Box className={styles.footerBottom}>
              <Box mb="4px">© 2024 Todayprice</Box>
              <Link to="/" className={styles.privacyLink}>
                Политика конфиденциальности
              </Link>
            </Box>
          </Paper>
        </BootstrapGrid.Item>
      </BootstrapGrid.Row>
    </PageContainer>
  );
};
